import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../components/Icon';
import { TOP_PRODUCTS } from '../mockData';

const TopProducts = () => {
  const { t } = useTranslation();

  return (
  <section className="stats-card">
    <header className="stats-card-head">
      <div>
        <h3 className="stats-card-title">{t('statistics.products.title')}</h3>
        <p className="stats-card-subtitle">{t('statistics.products.subtitle')}</p>
      </div>
      <button type="button" className="stats-btn stats-btn--solid">
        <Icon name="eye" size={14} />
        {t('statistics.products.viewAll')}
      </button>
    </header>

    <ul className="stats-rows">
      {TOP_PRODUCTS.map((product, index) => (
        <li className="stats-row" key={product.id}>
          <span className="stats-rank">#{index + 1}</span>
          <span className="stats-row-main">
            <span className="stats-row-title">
              {product.name}
              <span className="stats-tag">{product.tag}</span>
            </span>
            <span className="stats-row-sub">
              <Icon name="star-fill" size={12} /> {product.rating} • {t('statistics.products.sales', { count: product.sales })}
            </span>
          </span>
          <span className="stats-row-meta">
            <span className="stats-row-amount-line">
              <span className="stats-row-amount">{product.revenue}</span>
              <span className="stats-badge stats-badge--up">
                <Icon name="trending-up" size={12} />
                {product.delta}
              </span>
            </span>
            <span className="stats-stock">
              <span className="stats-row-sub">{t('statistics.products.stock', { count: product.stock })}</span>
              <span className="stats-progress">
                <span
                  className="stats-progress-fill"
                  style={{ width: `${Math.min(100, (product.stock / product.stockMax) * 100)}%` }}
                />
              </span>
            </span>
          </span>
        </li>
      ))}
    </ul>
  </section>
  );
};

export default TopProducts;
